(() => {
  // Only run if badges exist
  if (!document.querySelector('[data-ndd-badge]')) return;
  
  const updateBadges = () => {
    const now = new Date();
    const day = now.getDay();
    
    // Hide on weekends
    if (day === 0 || day === 5 || day === 6) {
      document.querySelectorAll('[data-ndd-badge]').forEach(badge => {
        badge.style.display = 'none';
      });
      return;
    }
    
    // Check if express time
    const isExpress = now.getHours() > 11 || (now.getHours() === 11 && now.getMinutes() >= 30);
    
    document.querySelectorAll('[data-ndd-badge] .ndd-badge__text').forEach(textEl => {
      const currentIsExpress = textEl.dataset.express === 'true';
      if (currentIsExpress !== isExpress) {
        textEl.dataset.express = isExpress;
        textEl.textContent = isExpress ? 'Express Delivery' : 'Next Day Delivery';
      }
    });
  };
  
  // Update every minute
  updateBadges();
  setInterval(updateBadges, 60000);
})();